import component from './i18nTranslates.vue'

export default component
